import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import HotspotContent from '@amblique/king-living/app/components/hotspot-content';
import {PlusIcon} from '@amblique/king-living/app/components/icons';

/**
 * Hotspot
 * @param {Object} props
 * @param {Object} props.left
 * @param {Object} props.top
 * @param {Function} props.onClick
 */
const Hotspot = ({
  authorName,
  authorTitle,
  authorImage,
  left,
  top,
  onClick,
  ...props
}) => {
  const styles = useMultiStyleConfig('Hotspot', {});
  const [activeHotspot, setActiveHotspot] = useState(null);

  const handleHotspotHover = () => {
    setActiveHotspot(true);
  };

  const handleHotspotLeave = () => {
    setActiveHotspot(false);
  };

  return (
    <Box {...styles.hotspot}
      left={left}
      top={top}
      onClick={onClick}
      {...props}
      onMouseEnter={() => handleHotspotHover()}
      onMouseLeave={() => handleHotspotLeave()}
    >
      <Box {...styles.hotspotIcon}>
        <PlusIcon />
      </Box>
      {activeHotspot && (
        <HotspotContent
          authorImage={authorImage}
          authorName={authorName}
          authorTitle={authorTitle}
          onClick={onClick}
        />
      )}
    </Box>
  );
};

Hotspot.propTypes = {
  authorName: PropTypes.string,
  authorTitle: PropTypes.string,
  authorImage: PropTypes.string,
  left: PropTypes.string,
  top: PropTypes.string,
  onClick: PropTypes.func,
};

export default Hotspot;
